import { PersonTypes } from '@frontend/api-person';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

type CalendarEventsFormTypeStoreType = {
  selectedForm: '' | SchedulerV3.Types.CalendarEventsEnums;
  setSelectedForm: (value: '' | SchedulerV3.Types.CalendarEventsEnums) => void;
  selectedPerson: null | PersonTypes.Person;
  setSelectedPerson: (value: null | PersonTypes.Person) => void;
};

const useCalendarEventsFormTypeStore = createStoreWithSubscribe<CalendarEventsFormTypeStoreType>(
  (set) => ({
    selectedForm: '',
    selectedPerson: null,
    setSelectedForm: (value) => set({ selectedForm: value }),
    setSelectedPerson: (value) => set({ selectedPerson: value }),
  }),
  {
    name: 'calendarEventsFormTypeStore',
  }
);

export const useCalendarEventsFormTypeShallowStore = createShallowStore(useCalendarEventsFormTypeStore);
